<template>
  <div class="layout-home-banner-item" @click="handleClick">
    <img
      :src="data.iconUrlV2"
      v-show="!collapsed && (+data.releaseType !== 20)"
      :class="{'banner-img-disable': ![1, 3].includes(+data.skipType)}"
      class="banner-img"/>
    <div v-show="!collapsed && +data.releaseType === 20" class="video-box">
      <div class="play-btn"><div class="triangle"></div></div>
      <img :src="data.iconUrlV2" alt="" class="video-poster"  />
    </div>
    <div class="collapse-title" v-show="collapsed">
      <i class="yinliang layout layout-tms-yinliangDisable" />
      <span class="notice-content">{{data.name}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: Object,
      collapsed: Boolean
    },
    methods: {
      handleClick (data) {
        this.$emit('click', this.data)
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-home-banner-item {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  .banner-img {
    display: block;
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 4px;
    cursor: pointer;
    -webkit-user-drag: none;
     &-disable {
      cursor: initial;
      -webkit-user-drag: none;
     }
  }
  .video-box {
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;
    video {
      width: 100%;
      height: 100%;
    }
    .video-poster {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      object-fit: cover;
      width: 100%;
      z-index: 100;
      -webkit-user-drag: none;
      outline: none;
      border: none;
      border-radius: 4px;
    }
    .play-btn {
      position: absolute;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      z-index: 101;
      background: rgba(0, 0, 0, 0.5);
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      .triangle {
        width: 0;
        height: 0;
        border-top: 8px solid transparent;  /* 左边透明 */
        border-bottom: 8px solid transparent; /* 右边透明 */
        border-left: 12px solid #fff;  /* 底边白色，高度通过勾股定理计算获得 */
        margin-left: 3px;
      }
    }
  }
  .collapse-title {
    padding-left: 14px;
    display: flex;
    align-items: center;
    i {
      color: var(--g-color-primary);
      margin-right: 4px;
    }
    .notice-content {
      height: 12px;
      line-height: 12px;
      font-size: 12px;
      padding-left: 4px;
    }
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/banner/banner-item.vue